import { LucideIcon } from "lucide-react"
import { Button } from "./button"
import { Card, CardContent } from "./card"

interface EmptyStateProps {
  icon: LucideIcon
  title: string
  description: string
  actionLabel?: string
  onAction?: () => void
  variant?: "default" | "card"
}

export function EmptyState({ 
  icon: Icon, 
  title, 
  description, 
  actionLabel, 
  onAction,
  variant = "default" 
}: EmptyStateProps) {
  const content = (
    <>
      <Icon className="w-12 h-12 mx-auto mb-4 text-muted-foreground" />
      <h3 className="text-lg font-semibold mb-2">{title}</h3>
      <p className="text-muted-foreground mb-4 max-w-md mx-auto">{description}</p>
      {actionLabel && onAction && (
        <Button onClick={onAction} className="mt-2">
          {actionLabel}
        </Button>
      )}
    </>
  )

  if (variant === "card") {
    return (
      <Card className="w-full">
        <CardContent className="flex flex-col items-center justify-center py-12 text-center">
          {content}
        </CardContent>
      </Card>
    )
  }

  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      {content}
    </div>
  )
}
